/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Modal klavye odağının DOM'dan bağımsız, deterministik sarma kararı.
 */

export type ModalTabDestination = 'native' | 'surface' | 'first' | 'last';

export interface ResolveModalTabDestinationInput {
    focusableCount: number;
    activeIndex: number;
    shiftKey: boolean;
}

export interface ModalTabOrderItem {
    tabIndex: number;
    documentIndex: number;
}

/** HTML sıralı odak kuralı: pozitif tabindex'ler önce, sonra DOM sıralı 0. */
export function compareModalTabOrder(
    left: ModalTabOrderItem,
    right: ModalTabOrderItem,
): number {
    const leftIsPositive = left.tabIndex > 0;
    const rightIsPositive = right.tabIndex > 0;

    if (leftIsPositive && rightIsPositive && left.tabIndex !== right.tabIndex) {
        return left.tabIndex - right.tabIndex;
    }
    if (leftIsPositive !== rightIsPositive) return leftIsPositive ? -1 : 1;
    return left.documentIndex - right.documentIndex;
}

/**
 * Tarayıcının doğal Tab akışı yalnız odak modal sınırında
 * kalıyorsa korunur; sınırda veya kapsam dışında deterministik hedef döner.
 */
export function resolveModalTabDestination({
    focusableCount,
    activeIndex,
    shiftKey,
}: ResolveModalTabDestinationInput): ModalTabDestination {
    if (focusableCount <= 0) return 'surface';
    if (activeIndex < 0) return shiftKey ? 'last' : 'first';
    if (shiftKey && activeIndex === 0) return 'last';
    if (!shiftKey && activeIndex === focusableCount - 1) return 'first';
    return 'native';
}
